// Força o menu hamburguer (drawer) em todas as telas — desktop e mobile
document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('#header-component');
  if (!header) return;

  // Força imediatamente
  header.dataset.menuStyle = 'drawer';

  // Observa mudanças e sempre reverte para drawer
  const observer = new MutationObserver(function () {
    if (header.dataset.menuStyle !== 'drawer') {
      header.dataset.menuStyle = 'drawer';
    }
  });

  observer.observe(header, {
    attributes: true,
    attributeFilter: ['data-menu-style'],
  });
});